// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ItemNavigation_Za1TG {
  @media (width<=768px) {
    display: flex;
    align-items: center;
    overflow-x: auto;
    overflow-y: clip;
  }

  li {
    text-decoration: none;
    color: var(--db-background);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    min-width: 100%;
    border-radius: 10px;
    cursor: pointer;

    &:hover {
      background-color: var(--_d7-background);
    }
  }
}

.ItemNavigation_Za1TG {
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  width: 95%;
  padding-left: 0;
  margin: 0px;

  .active_IFBLK {
    background-color: var(--ececf1-background);

    a,
    button {
      color: var(--_10a37f-background);
      font-weight: bold;
    }
  }


  li {
    list-style: none;
    height: 24px;
    display: flex;
    align-items: center;
    padding: 5px;
    color: var(--black-color);

    a,
    button {
      text-decoration: none;
      background-color: transparent;
      outline: none;
      border: none;
      color: var(--_3-color);
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;
      text-align: left;
      display: flex;
      align-items: center;
      gap: 5px;
      svg {
        height: 15px;
        width: 15px;
        color: #0D0D0D;
        fill: #0D0D0D;
       
      }
      .iconStoke_NEZTj{
        color: #0D0D0D;
         stroke:#0D0D0D
      }
      .activeIcon_pgbdL {
        color: #10a37f;
        fill: #10a37f;
        /* stroke:#10a37f; */
      }
      .activeIconStoke_wmJve{
         color: #10a37f;
          stroke:#10a37f; 
      }
    
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NavigationPopups/ItemNavigation/ItemNavigation.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,eAAe;;IAEf;MACE,uCAAuC;IACzC;EACF;AACF;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,WAAW;;EAEX;IACE,0CAA0C;;IAE1C;;MAEE,gCAAgC;MAChC,iBAAiB;IACnB;EACF;;;EAGA;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;;IAEzB;;MAEE,qBAAqB;MACrB,6BAA6B;MAC7B,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,WAAW;MACX,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,eAAe;MACf,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR;QACE,YAAY;QACZ,WAAW;QACX,cAAc;QACd,aAAa;;MAEf;MACA;QACE,cAAc;SACb;MACH;MACA;QACE,cAAc;QACd,aAAa;QACb,oBAAoB;MACtB;MACA;SACG,cAAc;UACb,cAAc;MAClB;;IAEF;EACF;AACF","sourcesContent":[".ItemNavigation {\n  @media (width<=768px) {\n    display: flex;\n    align-items: center;\n    overflow-x: auto;\n    overflow-y: clip;\n  }\n\n  li {\n    text-decoration: none;\n    color: var(--db-background);\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    min-width: 100%;\n    border-radius: 10px;\n    cursor: pointer;\n\n    &:hover {\n      background-color: var(--_d7-background);\n    }\n  }\n}\n\n.ItemNavigation {\n  cursor: pointer;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 95%;\n  padding-left: 0;\n  margin: 0px;\n\n  .active {\n    background-color: var(--ececf1-background);\n\n    a,\n    button {\n      color: var(--_10a37f-background);\n      font-weight: bold;\n    }\n  }\n\n\n  li {\n    list-style: none;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    padding: 5px;\n    color: var(--black-color);\n\n    a,\n    button {\n      text-decoration: none;\n      background-color: transparent;\n      outline: none;\n      border: none;\n      color: var(--_3-color);\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      text-align: left;\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      svg {\n        height: 15px;\n        width: 15px;\n        color: #0D0D0D;\n        fill: #0D0D0D;\n       \n      }\n      .iconStoke{\n        color: #0D0D0D;\n         stroke:#0D0D0D\n      }\n      .activeIcon {\n        color: #10a37f;\n        fill: #10a37f;\n        /* stroke:#10a37f; */\n      }\n      .activeIconStoke{\n         color: #10a37f;\n          stroke:#10a37f; \n      }\n    \n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ItemNavigation": `ItemNavigation_Za1TG`,
	"active": `active_IFBLK`,
	"iconStoke": `iconStoke_NEZTj`,
	"activeIcon": `activeIcon_pgbdL`,
	"activeIconStoke": `activeIconStoke_wmJve`
};
export default ___CSS_LOADER_EXPORT___;
